import React, { useState, useEffect } from "react";
import { useDocument } from "react-firebase-hooks/firestore";
import { firestore } from "./firebaseConfig";
import { doc,deleteDoc } from "firebase/firestore";
import { Link, useParams,useNavigate } from "react-router-dom";
import { getAuth } from "firebase/auth";
import './VehicleDetails.css'
const ViewLocalBusDetails = () => {
  const { documentId } = useParams();
  const [vehicleDetails, setVehicleDetails] = useState(null);
  const [snapshot, loading, error] = useDocument(
    doc(firestore, `Localbuses/${documentId}`)
  );
  const navigate = useNavigate();
  const auth = getAuth()
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (!user) {
        // If the user is not authenticated, navigate to the login page
        navigate("/login");
      }
    });

    // Cleanup the subscription when the component unmounts
    return () => unsubscribe();
  }, [navigate]);

  useEffect(() => {
    if (snapshot && snapshot.exists()) {
      setVehicleDetails(snapshot.data());
    }
  }, [snapshot, documentId]);
  const handleDelete = async () => {
    if (window.confirm("Are you sure you want to delete this document?")) {
      try {
        await deleteDoc(doc(firestore, `Localbuses/${documentId}`));
        console.log("Document successfully deleted!");
        // You can redirect the user or perform additional actions after deletion
        navigate("/DisplayCollegeBuses");
      } catch (error) {
        console.error("Error deleting document: ", error);
      }
    }
  };
  return (
    <div>
      {loading && <p>Loading...</p>}
      {error && (
        <p>
          Error: {error.message} <br />
          Check the console for more details.
        </p>
      )}
      {vehicleDetails && (
        <div className="scroll-table-container">
        <div style={{ display: 'flex', gap: '10px',alignItems: 'center', position: 'absolute', top: '30px', right: '20px' }}>
        <Link to={`/editlocalvehicle/${documentId}`} className="edit-button">
          Edit
        </Link>
        <button onClick={handleDelete} className="delete-button">
          Delete
        </button>
      </div>
        <h2>Vehicle Details</h2>
          <table>
            <thead>
              <tr>
                <th>Field</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>busNumber</td>
                <td>{vehicleDetails.busNumber}</td>
              </tr>
              <tr>
                <td>driverMobileNumber</td>
                <td>{vehicleDetails.driverMobileNumber}</td>
              </tr>
              <tr>
                <td>userEmail</td>
                <td>{vehicleDetails.userEmail}</td>
              </tr>
              <tr>
                <td>Stations</td>
                <td>
                  <div className="intermediate-stations-container">
                    <table>
                      <thead>
                        <tr>
                          <th>Place Name</th>
                          <th>Latitude</th>
                          <th>Longitude</th>
                        </tr>
                      </thead>
                      <tbody>
                        {vehicleDetails.Stations &&
                          vehicleDetails.Stations.map(
                            (station, index) => (
                              <tr key={index}>
                                <td>{station.placeName}</td>
                                <td>{station.latitude}</td>
                                <td>{station.longitude}</td>
                              </tr>
                            )
                          )}
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ViewLocalBusDetails;
